import { URLS } from '../../../constants';
import apiClient from '../../client';

const getAllUserAndGroupNamesAPI = {
  getAllUserAndGroupNames: ({ organizationId }: { organizationId: any }) =>
    apiClient.post(URLS.getAllUserAndGroupNames, {
      data: {
        organizationId,
      },
    }),
  getAllActiveTechnician: () =>
    apiClient.post(URLS.activeTechnician, {
      data: {},
    }),
};

export default getAllUserAndGroupNamesAPI;
